
import { RestApiResponse } from "../models/RestApiResponse";
import { ApiClient, FileParameter, TutorModel, TutorSummaryModel, UserModel, VerificationIdTypeEnum } from "../generated/api";
import CONFIG_KEYS from "../config"; 
import { customFetch } from "../middlewares/custom-fetch"; 

export class TutorService {

  private api: ApiClient;

  constructor(navigate?: (url: string) => void) {
    this.api = new ApiClient(CONFIG_KEYS.baseUrl, {fetch: customFetch
    });
  }
 
  public async UploadVerificatiom(
    verificationIdType: VerificationIdTypeEnum,
    idFrontFile: FileParameter,
    idBackFile: FileParameter | null | undefined,
    selfieFile: FileParameter
  ): Promise<RestApiResponse<TutorModel | undefined>> {
    const result = await this.api.uploadTutorIDFile(
      idFrontFile,
      idBackFile ?? undefined,
      selfieFile,
      verificationIdType);

    return new RestApiResponse<TutorModel | undefined>(result.data, result.message, result.isSuccess === true);
  }
    

  public async Save(tutor: TutorSummaryModel): Promise<RestApiResponse<TutorModel | undefined>> {
    // if (profileFile) {
    //   const uploadResponce = await this.api.uploadFile(profileFile.fileName, profileFile, FileTypeEnum.Thumbnail, undefined);
    //   tutor.profileUrl = uploadResponce.url;
    // }
  
    const usrJson= JSON.stringify(tutor)
    let result = await this.api.saveTutor(usrJson);

    return new RestApiResponse<TutorModel>(result.data, result.message, result.isSuccess === true);
  }

  
  public async UpdateVerificationStatus(tutorToken: string,isVerified :boolean ): Promise<RestApiResponse<UserModel | undefined>> {
     
    let result = await this.api.updateVerificationStatus(tutorToken, isVerified);

    return new RestApiResponse<UserModel>(result.data, result.message, result.isSuccess === true);
  }

  public async GetByToken(token?: string): Promise<TutorSummaryModel | undefined> {
    if (token)
      return await this.api.getTutorByToken(token);
    else
      return undefined;
  }
  public async GetGraphByToken(token?: string): Promise<TutorModel | undefined> {
    if (token)
      return await this.api.getTutorGraphByToken(token);
    else
      return undefined;
  }

  // Lightweight alternative to GetGraphByToken for callers that only need to know
  // a tutor's academy affiliation (e.g. Subscription Management) - avoids fetching
  // the full courses/lectures/followers graph just to read 3 fields.
  public async GetAcademyAffiliation(token?: string): Promise<{ academyToken?: string; academyName?: string; academyTagline?: string } | undefined> {
    if (!token) return undefined;
    const data = await this.api.getAcademyAffiliation(token); 
    return {
      academyToken: data.academyToken ,
      academyName: data.academyName ,
      academyTagline: data.academyTagline ,
    };
  }

  
  public async getInstructorVerificationList(): Promise<TutorModel[]> {
    return await this.api.instructorVerificationList();
  }

  public async getFollowing(): Promise<TutorSummaryModel[]> {
    return await this.api.getFollowing();
  }
 
  public async toggleFollowStatus(tutorToken: string): Promise<boolean> {
    return await this.api.tutorToggleFollow(tutorToken);
  } 
  
    public async SearchTutorForLectureInvitation(lectureToken?:string,keyword?: string, maxCount? :number): Promise<TutorModel[] | undefined> {
      if (keyword && lectureToken) {
        let result = await this.api.searchTutorForLectureInvitation(lectureToken,keyword,maxCount);
        return result;
      }
      else
        return undefined;
    }
};